<template>
  <div class="industry-targets">
    <p class="app-step-two-tabs-targeting-tabs__descr">
      Cision Influencer Lists are targeted email sends to individual journalists
      based on influence rating, topic- and industry-specific expertise.
      <span
        >Included in {{ packageName }}: {{ freeInfluencers }}. Additional
        Influencers are available at {{ additionalInfluencersPrice }} per
        additional Influencer.</span
      >
    </p>

    <targeting-list
      :selected-items="selectedItems"
      :resource-url="API.getInfluencerListsResource"
      payload-key-name="influencers"
    ></targeting-list>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useOrder } from '@core/composables/order/useOrder'

import API from '@core/api'
import TargetingList from '@modules/app-steps/step-two/tabs/targeting/targeting-list/index.vue'
import { formatPrice } from '@core/utils/price'

const { order } = useOrder()
const selectedItems = computed(() => order?.value?.influencers ?? [])

const packageName = computed(() => order?.value?.packagePrice?.package?.name)
const freeInfluencers = computed(
  () => order?.value?.packagePrice?.package?.influencers
)
const additionalInfluencersPrice = computed(() =>
  formatPrice(order?.value?.packagePrice?.package?.influencersPrice)
)
</script>
